module.exports = __webpack_public_path__ + "img/emmanuel_coutlee.e35243de.jpg";